import React from 'react';

import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const activeClasses = 'animate-shine bg-gradient-to-r from-[#13b8ff] to-[#098cc1] !py-[5px]';

const UnSavedChanges = ({
  isOpen,
  onSubmit,
  onClose,
  onCancel,
  saveButtonText = 'Save & Close'
}) => {
  return (
    <Confirm
      handleOpen={isOpen}
      handleClose={onClose}
      handleContinue={onClose}
      variant="danger"
      icon="wallet-mono"
      title="Unsaved changes"
      customClassName="min-w-fit"
      message="You have unsaved changes. Do you want to close this modal?"
      footer={
        <div className="flex items-center justify-between gap-2 xs:flex-col xs:items-start">
          <Button
            size="small"
            text="Yes, discard changes"
            color="danger"
            onClick={onCancel}
            textClassName="text-nowrap"
          />
          <div className="flex items-center gap-2">
            <Button
              outlined
              size="small"
              color="neutral"
              onClick={onClose}
              text="Keep editing"
              textClassName="text-nowrap"
            />
            <Button
              outlined
              size="small"
              text={saveButtonText}
              className={activeClasses}
              textClassName="text-white text-nowrap"
              onClick={() => {
                onSubmit();
                onClose();
              }}
            />
          </div>
        </div>
      }
    />
  );
};

export default UnSavedChanges;
